export enum Privatabrechnungsverfahren {
  VERRECHNUNGSTELLE = 'Verrechnungsstelle',
  RECHNUNGSDRUCK = 'Rechnungsdruck',
}
